import { UTCDateMini } from '@date-fns/utc';
import { Chip, Typography } from '@healthinal/ui';
import { differenceInYears } from 'date-fns';
import { PatientBasicsDto } from '../../api/generated/model';

export function AgeAndAgeCategoryAtCreation({ patient }: { patient: PatientBasicsDto }) {
  if (!patient.created) {
    return null;
  }
  const ageAtCreation = differenceInYears(new Date(patient.created), new UTCDateMini(patient.birthDate));
  return (
    <Typography
      textColor="text.secondary"
      endDecorator={
        <Chip component="span" size="md" variant={ageAtCreation < 17 ? 'solid' : 'soft'} sx={{ my: -0.5 }}>
          {getAgeCategoryName(ageAtCreation)}
        </Chip>
      }>
      {ageAtCreation}
    </Typography>
  );
}

function getAgeCategoryName(ageAtCreation: number) {
  if (ageAtCreation < 12) return '<12';
  if (ageAtCreation < 17) return '12-16';
  return '>16';
}
